import { render, staticRenderFns } from "./RichTextBlock.vue?vue&type=template&id=1cd26896&scoped=true"
import script from "./RichTextBlock.vue?vue&type=script&lang=js"
export * from "./RichTextBlock.vue?vue&type=script&lang=js"
import style0 from "./RichTextBlock.vue?vue&type=style&index=0&id=1cd26896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd26896",
  null
  
)

export default component.exports